import { render, staticRenderFns } from "./SeeMentionsButton.vue?vue&type=template&id=06cedeca"
import script from "./SeeMentionsButton.vue?vue&type=script&lang=js"
export * from "./SeeMentionsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports